import { useId } from "react";
import type { C1_Floor } from "../model/C1_Floor";
import type { C1_Project } from "../model/C1_Project";
import c1_state from "../model/C1_State";
import { C1_WallLayer } from "./C1_WallLayer";
import { C1_FreeWallsView } from "./C1_FreeWallsView";

export function C1_ReferenceFloorView({
  floor,
  project,
  layer,
}: {
  floor: C1_Floor;
  project: C1_Project;
  layer: "background" | "content";
}) {
  const view = c1_state.view;
  const px = c1_state.svgPx;
  const tintFilterId = useId();

  const roomElements = floor.rooms.map((room) => {
    const rect = room.rect();
    const x = (rect.x1 - view.x1) * px;
    const y = (rect.y1 - view.y1) * px;
    const width = (rect.x2 - rect.x1) * px;
    const height = (rect.y2 - rect.y1) * px;
    const textPosition = room.roomTextPosition;
    return (
      <g key={room.id} data-c1-room-id={room.id}>
        {layer === "background" && <polygon points={room.polygonPoints().map(point => `${(point.x - view.x1) * px},${(point.y - view.y1) * px}`).join(" ")} fill="#dbeafe" />}
        {layer === "content" && (
          <text
            x={x + width * textPosition.x}
            y={y + height * textPosition.y}
            textAnchor="middle"
            dominantBaseline="central"
            fill="#3979ad"
            fontSize={10.4}
          >
            ({(room.owner?.name ?? "")})
          </text>
        )}
      </g>
    );
  });

  return (
    <g data-c1-svg-layer="reference-floor" opacity={0.4} pointerEvents="none" aria-hidden="true">
      {roomElements}
      {layer === "content" && (
        <>
          <defs>
            <filter id={tintFilterId} colorInterpolationFilters="sRGB">
              <feFlood floodColor="#7aadd6" />
              <feComposite in2="SourceAlpha" operator="in" />
            </filter>
          </defs>
          <g filter={`url(#${tintFilterId})`}>
            <C1_WallLayer project={project} floor={floor} exterior={false} />
            <C1_WallLayer project={project} floor={floor} exterior />
            <C1_FreeWallsView floor={floor} />
          </g>
        </>
      )}
    </g>
  );
}
